<template>
  <div class="all">
    <img src="../assets/img/title.png" class="title" />
    <vs-alert :color="color">
      <template #title> 错误: {{ msg }} </template>
     
    </vs-alert>
  </div>
</template>

<script>
export default {
    mounted(){
        if(this.$route.query&&this.$route.query.msg){
            this.msg = this.$route.query.msg;
        }
        console.log(this.$route,'route');
    },
  data() {
    return {
        msg:"",
      color: "danger",
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 55%;
  max-width: 300px;
  margin-bottom: 1rem;
}
.all {
  background: #f5f5f5;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  padding: 2rem 0.2rem;
  box-sizing: border-box;
}
</style>
